import { render, staticRenderFns } from "./form-card-makanan-item.vue?vue&type=template&id=17f55cc6&"
import script from "./form-card-makanan-item.vue?vue&type=script&lang=js&"
export * from "./form-card-makanan-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CIcon: require('@chakra-ui/vue').CIcon, CFlex: require('@chakra-ui/vue').CFlex, CButton: require('@chakra-ui/vue').CButton, CText: require('@chakra-ui/vue').CText, CInput: require('@chakra-ui/vue').CInput, CBox: require('@chakra-ui/vue').CBox})
